import React from 'react';

export default function LayoutShell({ sidebar, drawer, children }) {
  return (
    <div className="flex items-start w-full relative min-h-screen">
      {/* Sidebar (optional) */}
      {sidebar && (
        <aside className="w-64 flex-shrink-0 border-r bg-white sticky top-0 max-h-screen">
          <div className="overflow-auto max-h-screen">
            {sidebar}
          </div>
        </aside>
      )}

      {/* Main content area */}
      <div className="flex-1 min-w-0">
        {children}
      </div>

      {/* Drawer (optional) */}
      {drawer && (
        <aside className="w-[40%] max-w-[480px] min-w-[320px] border-l bg-white overflow-auto shadow-xl">
          {drawer}
        </aside>
      )}
    </div>
  );
} 